"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.isHoldingStick = void 0;
/**
 * Returns `true` if the participant is the current speaker in the discussion.
 */
function isHoldingStick(discussion, participantId) {
    return discussion.stickHolderId === participantId;
}
exports.isHoldingStick = isHoldingStick;
//# sourceMappingURL=isHoldingStick.js.map